import type { OvpClient } from '@bldsoft/cappie/api/ovp'
import type { API } from '@setplex/tria-api'
import { payload } from '../../result'

export function use(
  client: OvpClient,
  support: API['support'],
  _api: API
): void {
  // POST /api/web/feedback/support
  support.setContactDataFx.use(async (params) => {
    payload(await client.post.api.web.feedback.support({ body: params }))
  })
}
